import { applyTheme, addCSS, addJS } from '@polleverywhere/participants-theme'
import { StatusBarStyle } from '@capacitor/core'

const hexComponent = (c) => ('0' + parseInt(c, 10).toString(16)).slice(-2)

const ensureHex = function (color) {
  const isHex = /#[0-9a-f]+/i.test(color)
  if (isHex) {
    return color
  }
  const rgb = /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)/i.exec(color)
  return (rgb && rgb.length === 4)
    ? '#' + hexComponent(rgb[1]) + hexComponent(rgb[2]) + hexComponent(rgb[3])
    : false
}

function removeCustomStyles (themeRootElement) {
  const $metaTheme = $('meta[name=theme-color]')
  themeRootElement.style.cssText = ''
  $('link[custom-user-style],script[custom-user-style],style[custom-user-style]').remove()
  $('.hold-screen--logo').addClass('icon').empty()
  $metaTheme.attr('content', $metaTheme.attr('data-default'))

  if (window.Capacitor.isNative) {
    window.Capacitor?.Plugins?.StatusBar?.setStyle({ style: StatusBarStyle.Dark })
  }

  // ios doesn't actually support setting statusbar colors
  // const statusColor = window.Capacitor?.platform === 'ios' ? $metaTheme.attr('data-default') : $metaTheme.attr('data-default-android-status')

  // window.StatusBar.setStyle({ style: StatusBarStyle.Dark })
  // window.StatusBar.backgroundColorByHexString(statusColor)
  // }
  /*
   * Removing the script doesn't actually do anything, so allow
   * custom scripts to cleanup by hooking into this event
   */
  themeRootElement.dispatchEvent(new CustomEvent('remove:custom-style', {
    bubbles: true
  }))
}

function applyCustomStyles (style, themeRootElement) {
  if (style.javascriptUrl) {
    addJS(style.javascriptUrl)
  }

  if (style.stylesheetUrl) {
    addCSS(style.stylesheetUrl)
  }

  let mobileTheme = style.mobileTheme
  if (mobileTheme) {
    if (typeof mobileTheme === 'string') { mobileTheme = JSON.parse(mobileTheme) }
    applyTheme(mobileTheme, themeRootElement)
    if (window.Capacitor?.isNative) {
      const statusColor = ensureHex(mobileTheme['header-background'])
      if (statusColor !== false) {
        // window.StatusBar.backgroundColorByHexString(statusColor)
      }
    }
  }
}

export function updateParticipantTheme (customStyle, themeRootElement) {
  if (customStyle) {
    applyCustomStyles(customStyle, themeRootElement)
  } else {
    removeCustomStyles(themeRootElement)
  }

  themeRootElement.toggleAttribute('data-custom-theme', !!customStyle)
}
